import AppearanceMenuIcons from "~/components/appearance-menu-icons";
import { CompanyInfoMenu } from "~/components/info/company-info-menu";
import LanguageSwitcher from "~/components/LanguageSwitcher";
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "~/components/ui/dropdown-menu";
import { urlFor } from "~/client";
import { useMobileNavigation } from "~/hooks/use_mobile_navigation";
import { Link } from "@inertiajs/react";
import { LogOut, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { Data } from "@generated/data";

type UserMenuContentProps = {
  companies: Data.Company[];
};

export function UserMenuContent({ companies }: UserMenuContentProps) {
  const { t } = useTranslation("home_common");
  const cleanup = useMobileNavigation();

  return (
    <>
      <DropdownMenuGroup>
        <CompanyInfoMenu companies={companies} />
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <Link
          className="block w-full"
          href={urlFor("profile.edit")}
          as="button"
          prefetch
          onClick={cleanup}
        >
          <Settings className="mr-2" />
          {t("settings")}
        </Link>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <Link
          className="block w-full"
          method="post"
          href={urlFor("logout")}
          as="button"
          onClick={cleanup}
        >
          <LogOut className="mr-2" />
          {t("logout")}
        </Link>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem className="focus:bg-transparent">
        <LanguageSwitcher />
        <AppearanceMenuIcons className="w-full justify-center" />
      </DropdownMenuItem>
    </>
  );
}
